module.exports = __webpack_public_path__ + "static/media/IMG-20220911-WA0005 - Sneha Mukhopadhyay.7f07ab56.jpg";